import { render, staticRenderFns } from "./CatalogDetails.vue?vue&type=template&id=2a40d2d8"
import script from "./CatalogDetails.vue?vue&type=script&lang=js"
export * from "./CatalogDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports